<template>
    <dashboard-layout title="교육 서비스" titBtn topBtn fullHeight>
        <template slot="titBtn">
            <lecture-list-help>
                <template #activator="{ attrs, on }">
                    <v-btn text icon x-large style="display:inline-flex" v-bind="attrs" v-on="on">
                        <v-icon x-large>mdi-help-circle-outline</v-icon>
                    </v-btn>
                </template>
            </lecture-list-help>
        </template>
        <template slot="topBtn">
            <lecture-form @input="updateItem" v-on="{ search }">
                <template #activator="{ attrs, on }">
                    <v-btn color="primary" v-bind="{ ...attrs, loading }" v-on="on">
                        <span> 영상 등록하기 </span>
                    </v-btn>
                </template>
            </lecture-form>
            <!-- 영상 등록하기 -->
            <!-- 실시간 스트리밍 -->
        </template>
        <template slot="contents">
            <template v-if="items.length">
                <!-- 카테고리 -->
                <div class="v-cards">
                    <v-row>
                        <template v-for="value in items">
                            <v-col cols="6" lg="4" :key="value._id">
                                <lecture-list-item
                                    v-bind="{
                                        value,
                                        loading,
                                    }"
                                    v-on="{
                                        search,
                                        remove,
                                    }"
                                />
                            </v-col>
                        </template>
                    </v-row>
                </div>
                <v-pagination :value="page" :length="pageCount" :total-visible="11" color="primary" @input="(page) => $router.push({ query: { ...$route.query, page } })"></v-pagination>
            </template>
            <template v-else>
                <v-layout column justify-center align-center class="w-100 h-100 grey-f7 rounded-lg pa-20">
                    <p class="page-text--lg line-height-15 text-center mb-12 mb-lg-32">
                        안녕하세요, 담당자님. <br />
                        등록된 영상이 없습니다.
                    </p>
                    <lecture-form @input="updateItem" v-on="{ search }">
                        <template #activator="{ attrs, on }">
                            <v-btn text height="auto" color="transparent" class="v-btn--column" v-bind="attrs" v-on="on">
                                <i class="icon icon-plus-lg" />
                                <span class="mt-6 mt-lg-14 grey-9--text">영상 등록하기</span>
                            </v-btn>
                        </template>
                    </lecture-form>
                </v-layout>
            </template>
        </template>
    </dashboard-layout>
</template>

<script>
import api from "@/api";

import DashboardLayout from "@/components/dashboard/dashboard-layout.vue";

import LectureForm from "@/components/dashboard/company/lecture/form/lecture-form.vue";
import LectureListHelp from "@/components/dashboard/company/lecture/list/lecture-list-help.vue";
import LectureListItem from "@/components/dashboard/company/lecture/list/lecture-list-item.vue";

export default {
    components: {
        DashboardLayout,

        LectureForm,
        LectureListHelp,
        LectureListItem,
    },
    data: () => ({
        loading: false,
        lectures: [],

        limit: 10,
        summary: { totalCount: 0 },

        showsSearch: true,
    }),
    computed: {
        items() {
            return this.lectures.map((item, index) => ({ ...item, index: this.summary.totalCount - (this.page - 1) * this.limit - index }));
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;
            return { ...query };
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.search();
        },
    },
    methods: {
        init() {
            this.search();
        },
        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { skip, limit, params } = this;
                var { summary, lectures } = await api.v1.company.lectures.gets({
                    headers: { skip, limit },
                    params,
                });

                this.lectures = lectures;
                this.summary = summary;
            } finally {
                if (this.loading) this.loading = false;
            }
        },
        async update(item) {
            if (this.loading) return;
            else this.loading = true;
            try {
                const { meeting } = await api.v1.company.lectures.put(item);
                this.loading = false;
                this.updateItem(meeting);
                this.search();
            } finally {
                if (this.loading) this.loading = false;
            }
        },
        async remove(item) {
            if (this.loading) return;
            else this.loading = true;
            try {
                await api.v1.company.lectures.delete(item);

                this.loading = false;
                this.search();
            } finally {
                if (this.loading) this.loading = false;
            }
        },
        updateItem(item) {
            const index = this.lectures.findIndex(({ _id }) => _id == item._id);
            if (0 <= index) this.lectures.splice(index, 1, item);
            else {
                this.lectures = [item, ...this.lectures];
                this.summary.totalCount += 1;
            }
        },
    },
};
</script>

<style></style>
